module.exports = __webpack_public_path__ + "img/vertical_4_2_6005.a1a98c08.png";